import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IInterview } from 'app/shared/model/interview.model';
import { getEntities as getInterviews } from 'app/entities/interview/interview.reducer';
import { IRecordedInterview } from 'app/shared/model/recorded-interview.model';
import { getEntity, updateEntity, createEntity, reset } from './recorded-interview.reducer';

export const RecordedInterviewUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const interviews = useAppSelector(state => state.interview.entities);
  const recordedInterviewEntity = useAppSelector(state => state.recordedInterview.entity);
  const loading = useAppSelector(state => state.recordedInterview.loading);
  const updating = useAppSelector(state => state.recordedInterview.updating);
  const updateSuccess = useAppSelector(state => state.recordedInterview.updateSuccess);

  const handleClose = () => {
    navigate('/recorded-interview' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getInterviews({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...recordedInterviewEntity,
      ...values,
      interview: interviews.find(it => it.id.toString() === values.interview.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...recordedInterviewEntity,
          interview: recordedInterviewEntity?.interview?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fivePlusApp.recordedInterview.home.createOrEditLabel" data-cy="RecordedInterviewCreateUpdateHeading">
            <Translate contentKey="fivePlusApp.recordedInterview.home.createOrEditLabel">Create or edit a RecordedInterview</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="recorded-interview-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fivePlusApp.recordedInterview.recordedInterviewId')}
                id="recorded-interview-recordedInterviewId"
                name="recordedInterviewId"
                data-cy="recordedInterviewId"
                type="text"
              />
              <ValidatedField
                id="recorded-interview-interview"
                name="interview"
                data-cy="interview"
                label={translate('fivePlusApp.recordedInterview.interview')}
                type="select"
              >
                <option value="" key="0" />
                {interviews
                  ? interviews.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/recorded-interview" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RecordedInterviewUpdate;
